import React, { useMemo } from "react";
import { shallowEqual, useSelector } from "react-redux";
import { redirectToPages } from "../../../../../../../_helpers/Helpers";
import { 
  Card, 
  CardBody, 
  CardHeader
} from "../../../../../../../_metronic/_partials/controls";
import { SectionsFilter } from "./receipent-sections-filter/SectionsFilter";
import { SectionsTable } from "./receipent-sections-table/SectionsTable";
import { useSectionsUIContext } from "./SectionsUIContext";

export function SectionsCard() {
  // Sections Card UI Context
  const sectionsUIContext = useSectionsUIContext();
  const sectionsUIProps = useMemo(() => {
    return {
      queryParams: sectionsUIContext.queryParams
    };
  }, [sectionsUIContext]);

  // Getting curret state of Sections from store (Redux)
  const { currentState } = useSelector(
    (state) => ({ currentState: state.privateNotices }),
    shallowEqual
  );  
  const { isSuccess, type } = currentState;
    
  // Yetki ve Hata Kontrolleri
  if (isSuccess === false) return redirectToPages(type);

  return (
    <Card>
      <CardHeader title="Gönderilen Sınıf Listesi" />
      <CardBody>
        <SectionsFilter />
        <SectionsTable />
      </CardBody>
    </Card>
  );
}